import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MapPin } from 'lucide-react';

export const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                <span className="text-slate-900 font-bold text-sm">L</span>
              </div>
              <span className="font-semibold text-lg">Logirent</span>
            </div>
            <p className="text-slate-400 max-w-sm leading-relaxed">
              {t('footer_tagline')}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold mb-4 text-slate-200">{t('footer_links')}</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('features')}
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  {t('nav_features')}
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('advantages')}
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  {t('nav_advantages')}
                </button>
              </li>
              <li>
                <a 
                  href="https://logitrak.ch"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-white transition-colors text-sm flex items-center gap-1"
                  data-testid="footer-logitrak-link"
                >
                  <MapPin className="w-3 h-3" />
                  Logitrak
                </a>
              </li>
              <li>
                <a 
                  href="/blog/"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                  data-testid="footer-blog-link"
                >
                  Blog
                </a>
              </li>
              <li>
                <a 
                  href="/a-propos/"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                  data-testid="footer-about-link"
                >
                  {t('footer_about')}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4 text-slate-200">{t('footer_contact')}</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  {t('nav_contact')}
                </button>
              </li>
              <li>
                <a 
                  href="#"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  {t('footer_legal')}
                </a>
              </li>
              <li>
                <a 
                  href="#"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  {t('footer_privacy')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} Logirent. {t('footer_copyright')}
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://logirent.ch/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-slate-500 hover:text-white transition-colors text-sm"
              >
                logirent.ch
              </a>
              <span className="text-slate-700">|</span>
              <a 
                href="https://logitrak.ch" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-slate-500 hover:text-white transition-colors text-sm"
              >
                logitrak.ch
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
